import {
    PasswortVergessenPageComponent,
    DatenschutzPageComponent,
    DisclaimerPageComponent,
    ImpressumPageComponent,
    LoginPageComponent,
} from 'kkm-library';
import {Routes, RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';

import {SommertrainingPageComponent} from './pages/training/sommertraining-page/sommertraining-page.component';
import {WintertrainingPageComponent} from './pages/training/wintertraining-page/wintertraining-page.component';
import {AnmeldungSatzungPageComponent} from './pages/anmeldung-satzung-page/anmeldung-satzung-page.component';
import {KalenderPageComponent} from './modules/kalender/kalender-page/kalender-page.component';
import {StartseitePageComponent} from './pages/startseite-page/startseite-page.component';
import {BootshausPageComponent} from './pages/bootshaus-page/bootshaus-page.component';
import {VorstandPageComponent} from './pages/vorstand-page/vorstand-page.component';
import {AnfahrtPageComponent} from './pages/anfahrt-page/anfahrt-page.component';
import {NewsPageComponent} from './modules/news/news-page/news-page.component';
import {LayoutComponent} from './layout/layout.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/startseite',
        pathMatch: 'full',
    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: 'startseite',
                component: StartseitePageComponent,
                data: {title: 'Startseite', description: 'Startseite mit News'},
            },
            {
                path: 'news',
                component: NewsPageComponent,
                data: {title: 'Berichte', description: 'Berichte über Aktivitäten des Vereins'},
            },
            {
                path: 'verein',
                children: [
                    {path: '', redirectTo: 'vorstand', pathMatch: 'full'},
                    {
                        path: 'vorstand',
                        component: VorstandPageComponent,
                        data: {title: 'Vorstand', description: 'Kontaktmöglichkeiten Vorstand'},
                    },
                    {
                        path: 'bootshaus',
                        component: BootshausPageComponent,
                        data: {title: 'Bootshaus', description: 'Beschreibung des Bootshauses'},
                    },
                    {
                        path: 'kalender',
                        component: KalenderPageComponent,
                        data: {title: 'Termine', description: 'Termine des Kanu-Klubs Mühlheim e.V.'},
                    },
                    {
                        path: 'anmeldung',
                        component: AnmeldungSatzungPageComponent,
                        data: {title: 'Anmeldung', description: 'Anmeldung und Mitgliedsbeitrag'},
                    },
                    {
                        path: 'anfahrt',
                        component: AnfahrtPageComponent,
                        data: {title: 'Anfahrt', description: 'Wegbeschreibung zum Verein'},
                    },
                    // {path: 'downloads', component: DownloadsComponent},
                ],
            },
            {
                path: 'training',
                children: [
                    {path: '', redirectTo: 'sommertraining', pathMatch: 'full'},
                    {
                        path: 'sommertraining',
                        component: SommertrainingPageComponent,
                        data: {title: 'Sommertraining', description: 'Training im Sommer'},
                    },
                    {
                        path: 'wintertraining',
                        component: WintertrainingPageComponent,
                        data: {title: 'Wintertraining', description: 'Training im Winter'},
                    },
                ],
            },

            {path: 'login', component: LoginPageComponent, data: {title: 'Login', description: 'Loginformular'}},
            {
                path: 'passwortVergessen',
                component: PasswortVergessenPageComponent,
                data: {title: 'Passwort vergessen', description: 'Passwort vergessen Formular'},
            },

            //         {
            //             path: 'mitgliederbereich',
            //             loadChildren: () =>
            //                 import('./modules/mitgliederbereich/mitgliederbereich-routing.module').then(
            //                     m => m.MitgliederbereichRoutingModule,
            //                 ),
            //             data: {
            //                 title: 'Mitgliederbereich',
            //                 description: 'interner Bereich für Mitglieder',
            //                 robots: 'noindex, nofollow',
            //             },
            //         },
            {
                path: 'impressum',
                component: ImpressumPageComponent,
                data: {title: 'Impressum', description: 'Impressum'},
            },
            {
                path: 'disclaimer',
                component: DisclaimerPageComponent,
                data: {title: 'Disclaimer', description: 'Disclaimer'},
            },
            {
                path: 'datenschutz',
                component: DatenschutzPageComponent,
                data: {title: 'Datenschutz', description: 'Datenschutzerklärung'},
            },
        ],
    },

    // {
    //   path: 'error',
    //   component: ErrorLandingPageComponent
    // }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            bindToComponentInputs: true,
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
